import { Text18 } from "components/Text";

export default function TemplateActionText({ text }: { text: string }) {
  return (
    <Text18 fontStyle="italic">
      The task assignee will be prompted to
      {" "}
      <Text18 fontWeight="bold" display="inline">
        {text}
      </Text18>
      , similar to this image below.
    </Text18>
  );
}
